import React, { FunctionComponent } from 'react';
import styles from './items-in-row.module.scss';

import { addSpace } from '../../utils/utils';
import Section from '../section/section';

export interface IItemsInRowComponentProps {
  children: IKontentItem[];
  additionalStyle: string | undefined;
  aligment: string;
}

export const ItemsInRowComponent: FunctionComponent<IItemsInRowComponentProps> = props => {
  const { children, additionalStyle, aligment } = props;

  return (
    <div className={styles.itemsWrapper} style={{ justifyContent: aligment }}>
      {children &&
        children.map((item: IKontentItem, i) => (
          <div key={i} style={additionalStyle ? addSpace(additionalStyle) : {}}>
            <Section linkedItem={item} key={item.id} />
          </div>
        ))}
    </div>
  );
};
